import axios from 'axios';


function PWC ({ apiKey, credentials, callback, id }) {
    if(typeof apiKey !== 'string'){
        throw new Error('apiKey should be string');
    }

    const isProduction = window.location.href.includes('https://auth.powercred.io')||window.location.href.includes('https://docs.julo.co.id');
    const baseURL = isProduction ? 'https://dev.powercred.io' : 'https://mock.powercred.io';
    const bucketOCR = isProduction ? 'powercred-profiles-indo' : 'powercred-profiles-indo-dev';

    const eCommerceList = [
        {
            code: 'instagram',
            name: 'Instagram',
            icon: './images/instagram_icon.png',
            category: 'Social',
            isSelected: false,
            params: [
                { key: 'profile_id', value: '', label: 'Enter your profile id:', placeHolder: 'Enter profile id'}
            ],
            modalInfo: {
                title: 'Instagram Authorization',
                specialNote: null,
            },
            isOAuth: true,
            isNewProcess: true,
            getOAuthURL(data){
                return data;
            },
            getAuthConfig(){
                return {
                    method: 'GET',
                    url: '/instagram/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'GET',
                    url: '/instagram/profile',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'tiktok',
            name: 'tiktok',
            icon: './images/tiktok.png',
            category: 'E-Commerce',
            isSelected: false,
            params: [
                { key: 'profile_id', value: '', label: 'Enter your profile id:', placeHolder: 'Enter profile id'}
            ],
            modalInfo: {
                title: 'Tiktok Authorization',
                specialNote: null,
            },
            isOAuth: true,
            isNewProcess: true,
            getOAuthURL(data){
                return data.url;
            },
            getAuthConfig(){
                return {
                    method: 'GET',
                    url: '/tiktok/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'GET',
                    url: '/tiktok/api/profile',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'lazada',
            name: 'Lazada',
            icon: './images/lazada_icon.png',
            category: 'E-Commerce',
            isSelected: false,
            params: [
                { key: 'region', value: '', label: 'Please select your region', type: 'options', options: ['Indonesia', 'Singapore', 'Malaysia', 'Thailand', 'Vietnam', 'Philippines']}
            ],
            modalInfo: {
                title: 'Authorize Lazada Seller',
                specialNote: null,
            },
            isOAuth: true,
            isNewProcess: true,
            getAuthConfig(){
                return {
                    method: 'GET',
                    url: '/lazada/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      region: getValueOfkey(this.params, 'region'),
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'GET',
                    url: '/lazada/api/profile',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'shopee',
            name: 'Shopee',
            icon: './images/shopee.png',
            category: 'E-Commerce',
            isSelected: false,
            params: [
                { key: 'shop_name', value: '', label: 'Shopee shop name:', placeHolder: 'Enter your Shopee shop name'}
            ],
            modalInfo: {
                title: 'Shopee Authorization',
                specialNote: null,
            },
            isOAuth: true,
            isNewProcess: true,
            getOAuthURL(data){
                return data.url;
            },
            getAuthConfig(){
                return {
                    method: 'GET',
                    url: '/shopee/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'GET',
                    url: '/shopee/profile',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'blibli',
            name: 'Blibli',
            icon: './images/blibli.png',
            category: 'E-Commerce',
            isSelected: false,
            params: [
                { key: 'username', value: '', label: 'Blibli seller registered email id', placeHolder: 'Enter your Blibli seller registered email id'},
                { key: 'store_code', value: '', label: 'Store id', placeHolder: 'Enter your Store id'},
                { key: 'api_seller_key', value: '', label: 'API seller key:', placeHolder: 'Enter your API seller key'}
            ],
            modalInfo: {
                title: 'Blibli Authorization',
                specialNote: '*Note: Seller have to bind our API Client ID before entering below details.',
                linkURL: '/BlibliStoreBindReference',
                link: 'How to bind and connect your Blibli store?'
            },
            isAuth: true,
            isNewProcess: true,
            handleAuthError(error){
                if(error.detail && error.detail.error && error.detail.error === 'Data not found! Please bind your blibli store with PowerCred to proceed'){
                    errorMessage = error.detail.error;
                }
            },
            getAuthConfig(){
                return {
                    method: 'GET',
                    url: '/blibli/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      api_seller_key: getValueOfkey(this.params, 'api_seller_key'),
                      store_code: getValueOfkey(this.params, 'store_code'),
                      username: getValueOfkey(this.params, 'username'),
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'GET',
                    url: '/blibli/api/profile',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'xero',
            name: 'Xero',
            icon: './images/xero.png',
            category: 'Accounting',
            isSelected: false,
            params: [
                { key: 'business_name', value: '', label: 'Enter your organization name:', placeHolder: 'Enter organization name'}
            ],
            modalInfo: {
                title: 'Xero Authorization',
                specialNote: null,
            },
            isOAuth: true,
            isNewProcess: true,
            getOAuthURL(data){
                return data.url;
            },
            getAuthConfig(){
                return {
                    method: 'GET',
                    url: '/xero/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      business_name: getValueOfkey(this.params, 'business_name')
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'GET',
                    url: '/xero/api/profile',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey,
                    },
                    headers: {'Content-Type': 'application/json'}
                  };
            }
        },
        {
            code: 'location',
            name: 'Google Location',
            icon: './images/gl_icon.jpg',
            category: 'Social',
            isSelected: false,
            params: [
                { key: 'place_search_text', value: '', label: 'Enter place name', placeHolder: 'Ex: Google Singapore, Sarasbaug Pune'}
            ],
            modalInfo: {
                title: 'Google Location Fetching',
                specialNote: null,
            },
            isNewProcess: true,
            getProfileConfig(){
                return {
                    method: 'GET',
                    url: '/location/api/profile',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey,
                        place_search_text: getValueOfkey(this.params, 'place_search_text'),
                    },
                    headers: {'Content-Type': 'application/json'}
                  };
            }
        },
        {
            code: 'tokopedia',
            name: 'Tokopedia',
            icon: './images/tokopedia.png',
            category: 'E-Commerce',
            isSelected: false,
            params: [
                { key: 'shop_url', value: '', label: 'Enter your Shop URL', placeHolder: 'Enter Shop URL'}
            ],
            modalInfo: {
                title: 'Tokopedia Authorization',
                specialNote: null,
            },
            isAuth: true,
            isNewProcess: true,
            messageAfterAuth: null,
            handleResponse(response){
                if(response.data.status_code && response.data.status_code == 404){
                    errorMessage = response.data.detail
                    throw 'Error in tokopedia';
                }
                else if(response.data.status_code && response.data.status_code == 403){
                    throw 'Error in tokopedia';
                }
                else if(response.data.seller_verification_required === true){
                    this.messageAfterAuth = {
                        body: 'Please check your email to approve the link and proceed to the next step.',
                        head: 'Authorization'
                    };
                }
                else{
                    this.messageAfterAuth = null;
                }
            },
            handleAuthError(){
                error = 'Please check your shop url';
            },
            getAuthConfig(){
                return {
                    method: 'POST',
                    url: '/tokopedia/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      shop_url: getValueOfkey(this.params, 'shop_url')
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'POST',
                    url: '/tokopedia/api/profile',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'bankconnect',
            name: 'Retail/Personal Banking',
            icon: '',
            category: 'Retail/Personal Banking',
            isSelected: false,
            params: [
                { key: 'username', value: '', label: 'Username', placeHolder: 'Enter Username'},
                { key: 'password', value: '', type: 'password', label: 'Password', placeHolder: 'Enter Password'}
            ],
            modalInfo: {
                title: 'Retail/Personal Banking Authorization',
                specialNote: null,
            },
            banks: [
                {
                    code: 'bca_bc',
                    name: 'BCA',
                    icon: './images/BCA.png',
                    isSelected: false,
                    data: { bank_code: 'BCA_PERSONAL' }
                    // data: { institution_id: 2 }
                },
                {
                    code: 'bri_bc',
                    name: 'BRI',
                    icon: './images/BRI.webp',
                    isSelected: false,
                    data: { bank_code: 'BRI_PERSONAL' }
                    // data: { institution_id: 5 }
                },
                {
                    code: 'bni_bc',
                    name: 'BNI',
                    icon: './images/BNI.webp',
                    isSelected: false,
                    data: { bank_code: 'BNI_PERSONAL' }
                    // data: { institution_id: 4 }
                },
                {
                    code: 'mandiri_bc',
                    name: 'Mandiri',
                    icon: './images/Mandiri.webp',
                    isSelected: false,
                    data: { bank_code: 'MANDIRI_PERSONAL' }
                    // data: { institution_id: 3 }
                }
            ],
            isAuth: true,
            isNewProcess: true,
            data: { 
                // institution_id: null 
                bank_code: null 
            },
            handleResponse(response){
                if(response.data.status_code && response.data.status_code == 403){
                    errorMessage = 'Please check your account credentials and try again!'
                    throw 'Invalid Bank account credentials';
                }
            },
            getAuthConfig(){
                return {
                    method: 'GET',
                    // url: '/banking/auth',
                    url: '/altconnect/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      username: getValueOfkey(this.params, 'username'),
                      password: getValueOfkey(this.params, 'password'),
                    //   institution_id: this.data.institution_id
                      bank_code:  this.data.bank_code
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    // method: 'POST',
                    // url: '/banking/profile',
                    method: 'GET',
                    url: '/altconnect/api/profile',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'bankVerification',
            name: 'Bank Verification',
            icon: '',
            category: 'Bank Verification',
            isSelected: false,
            params: [
                { key: 'name', value: '', label: 'Name', placeHolder: 'Enter Name'},
                { key: 'nik', value: '', label: 'NIK', placeHolder: 'Enter NIK'},
                { key: 'account_number', value: '', label: 'Account Number', placeHolder: 'Enter Account Number'}
            ],
            modalInfo: {
                title: 'Bank Verification',
                specialNote: null,
            },
            banks: [
                {
                    code: 'bca_bcv',
                    name: 'BCA',
                    icon: './images/BCA.png',
                    isSelected: false,
                    data: { bank_short_code: 'BCA' }
                },
                {
                    code: 'bri_bcv',
                    name: 'BRI',
                    icon: './images/BRI.webp',
                    isSelected: false,
                    data: { bank_short_code: 'BRI' }
                },
                {
                    code: 'bni_bcv',
                    name: 'BNI',
                    icon: './images/BNI.webp',
                    isSelected: false,
                    data: { bank_short_code: 'BNI' }
                },
                {
                    code: 'mandiri_bcv',
                    name: 'Mandiri',
                    icon: './images/Mandiri.webp',
                    isSelected: false,
                    data: { bank_short_code: 'MANDIRI' }
                },
                {
                    code: 'cimb_bcv',
                    name: 'CIMB',
                    icon: './images/CIMB.png',
                    isSelected: false,
                    data: { bank_short_code: 'CIMB_NIAGA' }
                },
                {
                    code: 'danamon_bcv',
                    name: 'Danamon',
                    icon: './images/danamon.png',
                    isSelected: false,
                    data: { bank_short_code: 'DANAMON' }
                }
            ],
            isAuth: true,
            isNewProcess: true,
            data: { 
                bank_short_code: null 
            },
            handleResponse(response){
                if(response.data.status_code && response.data.status_code == 403){
                    errorMessage = 'Please check your account credentials and try again!'
                    throw 'Invalid Bank account credentials';
                }
            },
            getAuthConfig(){
                return {
                    method: 'GET',
                    url: '/verification/banking',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      account_number: getValueOfkey(this.params, 'account_number'),
                      name: getValueOfkey(this.params, 'name'),
                      nik: getValueOfkey(this.params, 'nik'),
                      bank_short_code: this.data.bank_short_code
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'POST',
                    url: '/verification/banking/profile',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'altconnect',
            name: 'Corporate Banking',
            icon: '',
            category: 'Corporate Banking',
            isSelected: false,
            params: [
                { key: 'username', value: '', label: 'Username', placeHolder: 'Enter Username'},
                { key: 'password', value: '', type: 'password', label: 'Password', placeHolder: 'Enter Password'}
            ],
            modalInfo: {
                title: 'Corporate Banking Authorization',
                specialNote: null,
            },
            banks: [
                {
                    code: 'bca_ac',
                    name: 'BCA',
                    icon: './images/BCA.png',
                    isSelected: false,
                    data: { bank_code: 'BCA_CORPORATE' }
                },
                {
                    code: 'bni_ac',
                    name: 'BNI',
                    icon: './images/BNI.webp',
                    isSelected: false,
                    data: { bank_code: 'BNI_CORPORATE' }
                },
                {
                    code: 'mandiri_ac',
                    name: 'Mandiri',
                    icon: './images/Mandiri.webp',
                    isSelected: false,
                    data: { bank_code: 'MANDIRI_CORPORATE' }
                }
            ],
            isAuth: true,
            isNewProcess: true,
            data: { 
                bank_code: null 
            },
            getAuthConfig(){
                return {
                    method: 'GET',
                    url: '/altconnect/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      username: getValueOfkey(this.params, 'username'),
                      password: getValueOfkey(this.params, 'password'),
                      bank_code: this.data.bank_code
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'GET',
                    url: '/altconnect/api/profile',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'shopeeVerification',
            name: 'Shopee Verification',
            icon: './images/shopee.png',
            category: 'Shopee Verification',
            isSelected: false,
            params: [
                { key: 'username', value: '', label: 'Username', placeHolder: 'Enter your Username'},
                { key: 'accountNo', value: '', label: 'Account Number', placeHolder: 'Enter your Account Number'},
                { key: 'password', value: '', type: 'password', label: 'Password', placeHolder: 'Enter your Password'},
                { key: 'method', value: 'Whatsapp', label: 'Verify shopee account via', type: 'radio', values: [{name: 'Whatsapp' , value: 'Whatsapp'}, {name: 'SMS' , value: 'SMS'}]}
            ],
            modalInfo: {
                title: 'Shopee Verification'
            },
            isNewProcess: true,
            getProfileConfig(){
                return {
                    method: 'GET',
                    // url: '/shopee-verification/api/verifybank',
                    url: '/shopeeverification/api/verifybank',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      accountNo: getValueOfkey(this.params, 'accountNo'),
                      username: getValueOfkey(this.params, 'username'),
                      password: getValueOfkey(this.params, 'password'),
                      method: getValueOfkey(this.params, 'method'),
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            }
        },
        {
            code: 'tokopediaVerification',
            name: 'Tokopedia Verification',
            icon: './images/tokopedia.png',
            category: 'Tokopedia Verification',
            isSelected: false,
            params: [
                // { key: 'shop_url', value: '', label: 'Shop URL', placeHolder: 'Enter your Shop URL'},
                { key: 'bank_acc', value: '', label: 'Bank account', placeHolder: 'Enter your bank account'}
            ],
            modalInfo: {
                title: 'Tokopedia Authorization'
            },
            // isAuth: true,
            isNewProcess: true,
            messageAfterAuth: null,
            handleResponse(response){
                if(response.data.seller_verification_required === true){
                    this.messageAfterAuth = {
                        body: 'Please check your email to approve the link and proceed to the next step.',
                        head: 'Authorization'
                    };
                }
                else{
                    this.messageAfterAuth = null;
                }
            },
            handleAuthError(){
                error = 'Please check your shop url';
            },
            // getAuthConfig(){
            //     return {
            //         method: 'POST',
            //         url: '/tokopedia/auth',
            //         baseURL,
            //         params: {
            //           id: companyID,
            //           apikey: apiKey,
            //           shop_url: getValueOfkey(this.params, 'shop_url')
            //         },
            //         headers: {'Content-Type': 'application/json'}
            //     };
            // },
            getProfileConfig(){     // tokopedia verification
                return {
                    method: 'POST',
                    url: '/tokopedia/api/verification',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      bank_acc: getValueOfkey(this.params, 'bank_acc')
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'jurnal',
            name: 'Jurnal',
            icon: './images/jurnal_icon.png',
            category: 'E-Commerce',
            isSelected: false,
            params: [
                { key: 'user_email', value: '', label: 'Email id', placeHolder: 'Enter email id'}
            ],
            modalInfo: {
                title: 'Jurnal Authorization'
            },
            isOAuth: true,
            isNewProcess: true,
            getOAuthURL(data){
                return data.url;
            },
            getAuthConfig(){
                return {
                    method: 'GET',
                    url: '/jurnal/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      user_email: getValueOfkey(this.params, 'user_email'),
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'GET',
                    url: '/jurnal/api/profile',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'accurate',
            name: 'Accurate',
            icon: './images/accurate_icon.png',
            category: 'E-Commerce',
            isSelected: false,
            params: [],
            modalInfo: {
                title: 'Accurate Authorization'
            },
            isOAuth: true,
            isNewProcess: true,
            getOAuthURL(data){
                return data.url;
            },
            getAuthConfig(){
                return {
                    method: 'GET',
                    url: '/accurate/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'GET',
                    url: '/accurate/api/profile',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'quickbooks',
            name: 'Quickbooks',
            icon: './images/quickbooks_icon.png',
            category: 'E-Commerce',
            isSelected: false,
            params: [],
            modalInfo: {
                title: 'Quickbooks Authorization'
            },
            isOAuth: true,
            isNewProcess: true,
            getOAuthURL(data){
                return data;
            },
            getAuthConfig(){
                return {
                    method: 'GET',
                    url: '/quickbooks/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'GET',
                    url: '/quickbooks/profile',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'mokapos',
            name: 'Mokapos',
            icon: './images/mokapos_icon.png',
            category: 'Payment',
            isSelected: false,
            params: [
                { key: 'business_name', value: '', label: 'Business name:', placeHolder: 'Enter your business name'}
            ],
            modalInfo: {
                title: 'Mokapos Authorization'
            },
            isOAuth: true,
            isNewProcess: true,
            getOAuthURL(data){
                return data.redirect_url;
            },
            getAuthConfig(){
                return {
                    method: 'GET',
                    url: '/mokapos/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      business_name: getValueOfkey(this.params, 'business_name'),
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'POST',
                    url: '/mokapos/api/profile',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'plncheck',
            name: 'PlnCheck',
            icon: './images/plncheck_icon.png',
            category: 'Utility Bills',
            isSelected: false,
            params: [
                { key: 'customername', value: '', label: 'Customer name', placeHolder: 'Enter your customer name'},
                { key: 'phonenumber', value: '', type: 'number', label: 'Phone number', placeHolder: 'Enter your phone number'},
                { key: 'accountnumber', value: '', label: 'Account number', placeHolder: 'Enter your account number'}
            ],
            modalInfo: {
                title: 'PlnCheck Authorization'
            },
            isAuth: true,
            isNewProcess: true,
            getAuthConfig(){
                return {
                    method: 'GET',
                    url: '/plncheck/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      phonenumber: getValueOfkey(this.params, 'phonenumber'),
                      accountnumber: getValueOfkey(this.params, 'accountnumber'),
                      customername: getValueOfkey(this.params, 'customername'),
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'GET',
                    url: '/plncheck/api/profile',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'ovo',
            name: 'Ovo',
            icon: './images/ovo_icon.png',
            category: 'Payment',
            isSelected: false,
            params: [
                { key: 'username', value: '', label: 'Phone number', placeHolder: 'Enter your phone number'},
                { key: 'password', value: '', type: 'password', label: 'Pin', placeHolder: 'Enter your Pin'},
            ],
            paramsOTP: [
                { key: 'otp', value: '', type: 'number', label: 'OTP', placeHolder: 'Enter your Otp'},
            ],
            modalInfo: {
                title: 'Ovo Authorization'
            },
            isAuth: true,
            isNewProcess: true,
            handleResponse(response){
                if(!response.data.message || response.data.message !== 'Authentication under process, OTP sent successfully!'){
                    throw 'Authentication failed';
                }
            },
            handleOTPResponse(data){
                if(data !== 'Authentication Successful'){
                    throw 'OTP Authentication failed';
                }
            },
            getAuthConfig(){
                return {
                    method: 'GET',
                    url: '/ovo/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      username: getValueOfkey(this.params, 'username'),
                      password: getValueOfkey(this.params, 'password'),
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getOTPConfig(){
                return {
                    method: 'GET',
                    url: '/ovo/auth/otp',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      otp: getValueOfkey(this.paramsOTP, 'otp'),
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getProfileConfig(){
                return {
                    method: 'GET',
                    url: '/ovo/api/profile',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey
                    },
                    headers: {'Content-Type': 'application/json'}
                };                      
            }
        },
        {
            code: 'gopay',
            name: 'Gopay',
            icon: './images/gopay_icon.png',
            category: 'Payment',
            isSelected: false,
            params: [
                { key: 'contact', value: '', label: 'Phone number', placeHolder: 'Enter your phone number'},
                // { key: 'password', value: '', type: 'password', label: 'Pin', placeHolder: 'Enter your Pin'},
            ],
            paramsOTP: [
                { key: 'otp', value: '', type: 'number', label: 'OTP', placeHolder: 'Enter your Otp'},
            ],
            modalInfo: {
                title: 'Gopay Authorization'
            },
            isAuth: true,
            isNewProcess: true,
            handleAuthError(error){
                if(error.detail){
                    errorMessage = error.detail;
                }
            },
            // handleResponse(response){
            //     if(!response.data.message || response.data.message !== 'Authentication under process, OTP sent successfully!'){
            //         throw 'Authentication failed';
            //     }
            // },
            handleOTPResponse(data){
                if(data !== true){
                    throw {response: 'error'};
                }
            },
            handleOTPError(err){
                if(err.response && err.response.data && err.response.data.detail){
                    errorMessage = err.response.data.detail;
                }
            },
            getAuthConfig(){
                return {
                    method: 'POST',
                    url: '/gopay/auth',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      contact: getValueOfkey(this.params, 'contact'),
                    //   password: getValueOfkey(this.params, 'password'),
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            getOTPConfig(){
                return {
                    method: 'POST',
                    url: '/gopay/otp',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      otp: getValueOfkey(this.paramsOTP, 'otp'),
                    },
                    headers: {'Content-Type': 'application/json'}
                };
            },
            // getProfileConfig(){
            //     return {
            //         method: 'GET',
            //         url: '/gopay/profile',
            //         baseURL,
            //         params: {
            //             id: companyID,
            //             apikey: apiKey
            //         },
            //         headers: {'Content-Type': 'application/json'}
            //     };                      
            // }
        },
        {
            // for directly calling bca endpoint
            code: 'bca-old-focr',
            name: 'E-Statement Upload',
            icon: 'images/statement-upload.png',
            category: 'Bank E-statement Upload',
            isSelected: false,
            isAuth: true,
            isNewProcess: true,
            params: [
                { key: 'bank_name', value: 'BCA', label: 'Please select your bank', type: 'options', options: ['BCA', 'BNI', 'BRI', 'PERMATA', 'MANDIRI', 'DANAMON', 'JENIUS', 'BJB', 'DBS', 'CIMB', 'UNDEFINED'], infoMessage: 'Please select your bank account', labelT: 'Silakan pilih bank Anda', infoMessageT: 'Silakan pilih rekening bank Anda'},
                { key: 'password', value: '', type: 'password', label: 'PDF password', placeHolder: 'PDF password', infoMessage: 'PDF password', labelT: 'PDF password', placeHolderT: 'PDF password', infoMessageT: 'PDF password'},
                { key: 'files', value: '', type: 'file', label: 'Upload statement', placeHolder: 'Upload bank statement', infoMessage: 'Upload bank statement', labelT: 'Upload statement', placeHolderT: '', infoMessageT: ''}
            ],
            handleAuthError(error){
                if(error.detail){
                    errorMessage = error.detail;
                }
            },
            getAuthConfig(){
                return {
                    method: 'POST',
                    url: '/banking/bca/stmt/upload',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      bank_name: getValueOfkey(this.params, 'bank_name'),
                      password: getValueOfkey(this.params, 'password'),
                    },
                    data: getValueOfkey(this.params, 'files'),
                    // headers: {'Content-Type': 'multipart/form-data'}
                };
            },
        },
        {
            // for directly calling mandiri endpoint
            code: 'mandiri-old-ocr',
            name: 'E-Statement Upload',
            icon: 'images/statement-upload.png',
            category: 'Bank E-statement Upload',
            isSelected: false,
            isAuth: true,
            isNewProcess: true,
            params: [
                // { key: 'bank_name', value: 'BCA', label: 'Please select your bank', type: 'options', options: ['BCA', 'BNI', 'BRI', 'PERMATA', 'MANDIRI', 'DANAMON', 'JENIUS', 'BJB', 'DBS', 'CIMB', 'UNDEFINED'], infoMessage: 'Please select your bank account', labelT: 'Silakan pilih bank Anda', infoMessageT: 'Silakan pilih rekening bank Anda'},
                { key: 'password', value: '', type: 'password', label: 'PDF password', placeHolder: 'PDF password', infoMessage: 'PDF password', labelT: 'PDF password', placeHolderT: 'PDF password', infoMessageT: 'PDF password'},
                { key: 'files', value: '', type: 'file', label: 'Upload statement', placeHolder: 'Upload bank statement', infoMessage: 'Upload bank statement', labelT: 'Upload statement', placeHolderT: '', infoMessageT: ''}
            ],
            handleAuthError(error){
                if(error.detail){
                    errorMessage = error.detail;
                }
            },
            getAuthConfig(){
                return {
                    method: 'POST',
                    url: '/banking/mandiri/stmt/upload',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      password: getValueOfkey(this.params, 'password'),
                    },
                    data: getValueOfkey(this.params, 'files'),
                    // headers: {'Content-Type': 'multipart/form-data'}
                };
            },
        },
        {
            code: 'bca-focr',
            name: 'E-Statement Upload',
            icon: 'images/statement-upload.png',
            category: 'Bank E-statement Upload',
            isSelected: false,
            isAuth: true,
            isNewProcess: true,
            params: [
                // { key: 'bank_name', value: 'BCA', label: 'Please select your bank', type: 'options', options: ['BCA', 'BNI', 'BRI', 'PERMATA', 'MANDIRI', 'DANAMON', 'JENIUS', 'BJB', 'DBS', 'CIMB', 'UNDEFINED'], infoMessage: 'Please select your bank account', labelT: 'Silakan pilih bank Anda', infoMessageT: 'Silakan pilih rekening bank Anda'},
                { key: 'password', value: '', type: 'password', label: 'PDF password', placeHolder: 'PDF password', infoMessage: 'PDF password', labelT: 'PDF password', placeHolderT: 'PDF password', infoMessageT: 'PDF password'},
                { key: 'files', value: '', type: 'file', label: 'Upload statement', placeHolder: 'Upload bank statement', infoMessage: 'Upload bank statement', labelT: 'Upload statement', placeHolderT: '', infoMessageT: ''}
            ],
            handleAuthError(error){
                // if(error.detail){
                //     errorMessage = error.detail;
                // }
            },
            getSignedConfig(name){
                
                let converted_name = name.replace(/[ ,]/g, '_');
                const data = {
                    bucket: bucketOCR,
                    object: `raw/${companyID}/banking_ocr/multi_bank_ocr/${converted_name}`,                        
                    verb: 'PUT',
                  }
                  const params = new URLSearchParams();
                  for (const [key, value] of Object.entries(data)) {
                    params.append(key, value);
                  }
                return {

                    method: 'POST',
                    url: '/signurl/v4/real',
                    baseURL,
                    data: params.toString(),
                    headers: { 
                        'content-type': 'application/x-www-form-urlencoded'
                      },
                };
            },
            getAuthConfig(url,file){
                return {
                    method: 'PUT',
                    url,
                    data: file,
                    // headers: {'Content-Type': 'multipart/form-data'}
                };
            },
            getStmtConfig(filevalue){
                let data = new FormData();
                data.append('files',filevalue)
                return {
                    method: 'POST',
                    url: '/bank/analysis/stmt/upload',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey,   
                        bankname:'bca'         
                      },
                    data: data
                }
            }
        },
        {
            code: 'mandiri-ocr',
            name: 'E-Statement Upload',
            icon: 'images/statement-upload.png',
            category: 'Bank E-statement Upload',
            isSelected: false,
            isAuth: true,
            isNewProcess: true,
            params: [
                // { key: 'bank_name', value: 'MANDIRI', label: 'Please select your bank', type: 'options', options: ['BCA', 'BNI', 'BRI', 'PERMATA', 'MANDIRI', 'DANAMON', 'JENIUS', 'BJB', 'DBS', 'CIMB', 'UNDEFINED'], infoMessage: 'Please select your bank account', labelT: 'Silakan pilih bank Anda', infoMessageT: 'Silakan pilih rekening bank Anda'},
                { key: 'password', value: '', type: 'password', label: 'PDF password', placeHolder: 'PDF password', infoMessage: 'PDF password', labelT: 'PDF password', placeHolderT: 'PDF password', infoMessageT: 'PDF password'},
                { key: 'files', value: '', type: 'file', label: 'Upload statement', placeHolder: 'Upload bank statement', infoMessage: 'Upload bank statement', labelT: 'Upload statement', placeHolderT: '', infoMessageT: ''}
            ],
            handleAuthError(error){
                // if(error.detail){
                //     errorMessage = error.detail;
                // }
            },
            getSignedConfig(name){
                
                let converted_name = name.replace(/[ ,]/g, '_');
                const data = {
                    bucket: bucketOCR,
                    object: `raw/${companyID}/banking_ocr/multi_bank_ocr/${converted_name}`,                        
                    verb: 'PUT',
                  }
                  const params = new URLSearchParams();
                  for (const [key, value] of Object.entries(data)) {
                    params.append(key, value);
                  }
                return {

                    method: 'POST',
                    url: '/signurl/v4/real',
                    baseURL,
                    data: params.toString(),
                    headers: { 
                        'content-type': 'application/x-www-form-urlencoded'
                      },
                };
            },
            getAuthConfig(url,file){
                return {
                    method: 'PUT',
                    url,
                    data: file,
                    // headers: {'Content-Type': 'multipart/form-data'}
                };
            },
            getStmtConfig(filevalue){
                let data = new FormData();
                data.append('files',filevalue)
                return {
                    method: 'POST',
                    url: '/bank/analysis/stmt/upload',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey, 
                        bankname:'mandiri'            
                      },
                    data: data
                }
            }
        },
        {
            code: 'bri-ocr',
            name: 'E-Statement Upload',
            icon: 'images/statement-upload.png',
            category: 'Bank E-statement Upload',
            isSelected: false,
            isAuth: true,
            isNewProcess: true,
            params: [
                // { key: 'bank_name', value: 'BRI', label: 'Please select your bank', type: 'options', options: ['BCA', 'BNI', 'BRI', 'PERMATA', 'DANAMON', 'JENIUS', 'BJB', 'DBS', 'CIMB', 'UNDEFINED'], infoMessage: 'Please select your bank account', labelT: 'Silakan pilih bank Anda', infoMessageT: 'Silakan pilih rekening bank Anda'},
                { key: 'password', value: '', type: 'password', label: 'PDF password', placeHolder: 'PDF password', infoMessage: 'PDF password', labelT: 'PDF password', placeHolderT: 'PDF password', infoMessageT: 'PDF password'},
                { key: 'files', value: '', type: 'file', label: 'Upload statement', placeHolder: 'Upload bank statement', infoMessage: 'Upload bank statement', labelT: 'Upload statement', placeHolderT: '', infoMessageT: ''}
            ],
            handleAuthError(error){
                // if(error.detail){
                //     errorMessage = error.detail;
                // }
            },
            getSignedConfig(name){
                
                let converted_name = name.replace(/[ ,]/g, '_');
                const data = {
                    bucket: bucketOCR,
                    object: `raw/${companyID}/banking_ocr/multi_bank_ocr/${converted_name}`,                        
                    verb: 'PUT',
                  }
                  const params = new URLSearchParams();
                  for (const [key, value] of Object.entries(data)) {
                    params.append(key, value);
                  }
                return {

                    method: 'POST',
                    url: '/signurl/v4/real',
                    baseURL,
                    data: params.toString(),
                    headers: { 
                        'content-type': 'application/x-www-form-urlencoded'
                      },
                };
            },
            getAuthConfig(url,file){
                return {
                    method: 'PUT',
                    url,
                    data: file,
                    // headers: {'Content-Type': 'multipart/form-data'}
                };
            },
            getStmtConfig(filevalue){
                let data = new FormData();
                data.append('files',filevalue)
                return {
                    method: 'POST',
                    url: '/bank/analysis/stmt/upload',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey, 
                        bankname:'bri'            
                      },
                    data: data
                }
            }
        },
        {
            code: 'bni-ocr',
            name: 'E-Statement Upload',
            icon: 'images/statement-upload.png',
            category: 'Bank E-statement Upload',
            isSelected: false,
            isAuth: true,
            isNewProcess: true,
            params: [
                // { key: 'bank_name', value: 'BNI', label: 'Please select your bank', type: 'options', options: ['BCA', 'BNI', 'BRI', 'PERMATA', 'DANAMON', 'JENIUS', 'BJB', 'DBS', 'CIMB', 'UNDEFINED'], infoMessage: 'Please select your bank account', labelT: 'Silakan pilih bank Anda', infoMessageT: 'Silakan pilih rekening bank Anda'},
                { key: 'password', value: '', type: 'password', label: 'PDF password', placeHolder: 'PDF password', infoMessage: 'PDF password', labelT: 'PDF password', placeHolderT: 'PDF password', infoMessageT: 'PDF password'},
                { key: 'files', value: '', type: 'file', label: 'Upload statement', placeHolder: 'Upload bank statement', infoMessage: 'Upload bank statement', labelT: 'Upload statement', placeHolderT: '', infoMessageT: ''}
            ],
            handleAuthError(error){
                // if(error.detail){
                //     errorMessage = error.detail;
                // }
            },
            getSignedConfig(name){
                
                let converted_name = name.replace(/[ ,]/g, '_');
                const data = {
                    bucket: bucketOCR,
                    object: `raw/${companyID}/banking_ocr/multi_bank_ocr/${converted_name}`,                        
                    verb: 'PUT',
                  }
                  const params = new URLSearchParams();
                  for (const [key, value] of Object.entries(data)) {
                    params.append(key, value);
                  }
                return {

                    method: 'POST',
                    url: '/signurl/v4/real',
                    baseURL,
                    data: params.toString(),
                    headers: { 
                        'content-type': 'application/x-www-form-urlencoded'
                      },
                };
            },
            getAuthConfig(url,file){
                return {
                    method: 'PUT',
                    url,
                    data: file,
                    // headers: {'Content-Type': 'multipart/form-data'}
                };
            },
            getStmtConfig(filevalue){
                let data = new FormData();
                data.append('files',filevalue)
                return {
                    method: 'POST',
                    url: '/bank/analysis/stmt/upload',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey,
                        bankname:'bni'             
                      },
                    data: data
                }
            }
        },
        {
            code: 'bca-cocr',
            name: 'Corporate E-Statement Upload',
            icon: '',
            category: 'Corporate Bank E-statement Upload',
            isSelected: false,
            isAuth: true,
            isNewProcess: true,
            params: [
                { key: 'bank_name', value: 'BCA', label: 'Please select your bank', type: 'options', options: ['BCA', 'BNI', 'BRI', 'PERMATA', 'MANDIRI', 'DANAMON', 'JENIUS', 'BJB', 'DBS', 'CIMB', 'UNDEFINED'], infoMessage: 'Please select your bank account', labelT: 'Silakan pilih bank Anda', infoMessageT: 'Silakan pilih rekening bank Anda'},
                { key: 'password', value: '', type: 'password', label: 'PDF password', placeHolder: 'PDF password', infoMessage: 'PDF password', labelT: 'PDF password', placeHolderT: 'PDF password', infoMessageT: 'PDF password'},
                { key: 'files', value: '', type: 'file', label: 'Upload statement', placeHolder: 'Upload bank statement', infoMessage: 'Upload bank statement', labelT: 'Upload statement', placeHolderT: '', infoMessageT: ''}
            ],
            handleAuthError(error){
                if(error.detail){
                    // errorMessage = JSON.stringify(error.detail);
                    errorMessage = error.detail;
                }
            },
            getAuthConfig(){
                return {
                    method: 'POST',
                    url: '/banking/bca/stmt/upload',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      bank_name: getValueOfkey(this.params, 'bank_name'),
                      password: getValueOfkey(this.params, 'password'),
                    },
                    data: getValueOfkey(this.params, 'files'),
                    // headers: {'Content-Type': 'multipart/form-data'}
                };
            },
        },
        {
            code: 'bca-pocr',
            name: 'Retail/Personal E-Statement Upload',
            icon: '',
            category: 'Retail/Personal Bank E-statement Upload',
            isSelected: false,
            isAuth: true,
            isNewProcess: true,
            params: [
                { key: 'bank_name', value: 'BCA', label: 'Please select your bank', type: 'options', options: ['BCA', 'BNI', 'BRI', 'PERMATA', 'MANDIRI', 'DANAMON', 'JENIUS', 'BJB', 'DBS', 'CIMB', 'UNDEFINED'], infoMessage: 'Please select your bank account', labelT: 'Silakan pilih bank Anda', infoMessageT: 'Silakan pilih rekening bank Anda'},
                { key: 'password', value: '', type: 'password', label: 'PDF password', placeHolder: 'PDF password', infoMessage: 'PDF password', labelT: 'PDF password', placeHolderT: 'PDF password', infoMessageT: 'PDF password'},
                { key: 'files', value: '', type: 'file', label: 'Upload statement', placeHolder: 'Upload bank statement', infoMessage: 'Upload bank statement', labelT: 'Upload statement', placeHolderT: '', infoMessageT: ''}
            ],
            handleAuthError(error){
                if(error.detail){
                    errorMessage = error.detail;
                }
            },
            getAuthConfig(){
                return {
                    method: 'POST',
                    url: '/banking/bca/stmt/upload',
                    baseURL,
                    params: {
                      id: companyID,
                      apikey: apiKey,
                      bank_name: getValueOfkey(this.params, 'bank_name'),
                      password: getValueOfkey(this.params, 'password'),
                    },
                    data: getValueOfkey(this.params, 'files'),
                    // headers: {'Content-Type': 'multipart/form-data'}
                };
            },
        },
        {
            code: 'multi-bank-ocr',
            name: 'E-Statement Upload',
            icon: 'images/statement-upload.png',
            category: 'Bank E-statement Upload',
            isSelected: false,
            isAuth: true,
            isNewProcess: true,
            params: [
                // { key: 'bank_name', value: 'BCA', label: 'Please select your bank', type: 'options', options: ['BCA', 'BNI', 'BRI', 'PERMATA', 'DANAMON', 'JENIUS', 'BJB', 'DBS', 'CIMB', 'UNDEFINED'], infoMessage: 'Please select your bank account', labelT: 'Silakan pilih bank Anda', infoMessageT: 'Silakan pilih rekening bank Anda'},
                { key: 'password', value: '', type: 'password', label: 'PDF password', placeHolder: 'PDF password', infoMessage: 'PDF password', labelT: 'PDF password', placeHolderT: 'PDF password', infoMessageT: 'PDF password'},
                { key: 'files', value: '', type: 'file', label: 'Upload statement', placeHolder: 'Upload bank statement', infoMessage: 'Upload bank statement', labelT: 'Upload statement', placeHolderT: '', infoMessageT: ''}
            ],
            handleAuthError(error){
                // if(error.detail){
                //     errorMessage = error.detail;
                // }
            },
            getSignedConfig(name){
                
                let converted_name = name.replace(/[ ,]/g, '_');
                const data = {
                    bucket: bucketOCR,
                    object: `raw/${companyID}/banking_ocr/multi_bank_ocr/${converted_name}`,                        
                    verb: 'PUT',
                  }
                  const params = new URLSearchParams();
                  for (const [key, value] of Object.entries(data)) {
                    params.append(key, value);
                  }
                return {

                    method: 'POST',
                    url: '/signurl/v4/real',
                    baseURL,
                    data: params.toString(),
                    headers: { 
                        'content-type': 'application/x-www-form-urlencoded'
                      },
                };
            },
            getAuthConfig(url,file){
                return {
                    method: 'PUT',
                    url,
                    data: file,
                    // headers: {'Content-Type': 'multipart/form-data'}
                };
            },
            getStmtConfig(filevalue){
                let data = new FormData();
                data.append('files',filevalue)
                return {
                    method: 'POST',
                    url: '/bank/analysis/stmt/upload',
                    baseURL,
                    params: {
                        id: companyID,
                        apikey: apiKey,            
                      },
                    data: data
                }
            }
        },
    ];
    
    const data = {};

    let companyID = id;
    let previosCompanyID = null;

    let error = null;
    let errorMessage = null;

    const addData = (index) => {
        const eCommerce = eCommerceList[index]; 
        data[eCommerce.code] = eCommerce.params.reduce((prev, param) => {
            prev[param.key] = param.value;
            return prev;
        }, {});
    };

    const handleError = (err) => {
        if (err.response) {
            console.log("errors");
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
        }
        else {
            console.log(`Error: ${err.message}`);
        }
    };

    async function callPublish() {
        try {

            const config = {
                method: 'POST',
                url: '/bank/analysis/stmt/publish',
                baseURL,
                params: {
                    id: companyID,
                    apikey: apiKey,
                }
            };
            const response = await axios(config);
            return response.data;
        } catch (error) {
            console.error('Error calling the publish API:', error);
            throw error;
        }
    }

    const OauthBankings = async (index, oAuthWindow) => {
        const eCommerce = eCommerceList[index];
        try {
            let values = [];
            let fileArr = [];
            eCommerce.params[1].value.forEach(value => values.push(value))
           let response = await Promise.allSettled(
                values.map(value=>{
                 const fun = async() =>{
                   try{
                    // let converted_name = name.replace(/[ ,]/g, '_');
                    const responseValue = await axios(eCommerce.getStmtConfig(value));
                    //    console.log(responseValue)
                           
                  
                    if(responseValue.status == 202)
                   {//  fileArr.push(11)
                        fileArr.push(value)
                    }

                    // let signedurl = '';
                    // signedurl = await axios(eCommerce.getSignedConfig(value.name));
                    // signedurl = signedurl.data.signedurl;  
                    // signedUrlArr.push(signedurl);            
                    // const response = await axios(eCommerce.getAuthConfig(signedurl,value));
                    eCommerce.handleResponse && eCommerce.handleResponse(response);
                    return true;
                   }
                   catch (err){
                    handleError(err);          
                    eCommerce.handleAuthError && err.response && err.response.data && eCommerce.handleAuthError(err.response.data);
                    if(err.response && err.response.data && err.response.data.detail && Array.isArray(err.response.data.detail)){
                        errorMessage = undefined
                    }
                    return false;
                   }
                }
             return fun(); 
            }))
            const allStatusTrue = response.every((item) => item.value === true);
            if (allStatusTrue === true && fileArr.length !== 0){
                //  const responseValue = await axios(eCommerce.getStmtConfig(signedUrlArr));
                //    console.log(responseValue.data)

                // return true          
                return fileArr; 
            }
            else if(allStatusTrue == true && fileArr.length === 0)
            {
                try{
                    const publishResponse = await callPublish();
                    // console.log('publish api called',publishResponse)
                    return true;
                }
                catch(error){
                    console.log('error in calling publish api',error);
                    return false;
                }
              
                
            }
            return false;
       

            // return !response.find(value => !value);
        } catch (err) {
            
            return false;
        }
    };
    const oAuth = async (index, oAuthWindow) => {
        const eCommerce = eCommerceList[index];
        try {     
            let authURL;

                        const response = await axios(eCommerce.getAuthConfig());

            eCommerce.handleResponse && eCommerce.handleResponse(response);
            if(eCommerce.isOAuth){
                authURL = eCommerce.isNewProcess ? response.data : response.data.message; 
                if(eCommerce.getOAuthURL){
                    authURL = eCommerce.getOAuthURL(response.data);
                }
                if(authURL) {
                    oAuthWindow.location.href = authURL;
                }
            }
            return true;
        } catch (err) {
            handleError(err);
            eCommerce.isOAuth && oAuthWindow.close();
            eCommerce.handleAuthError && err.response && err.response.data && eCommerce.handleAuthError(err.response.data);
            if(err.response && err.response.data && err.response.data.detail && Array.isArray(err.response.data.detail)){
                errorMessage = undefined
            }
            return false;
        }
    };

    const getValueOfkey = (params, key) => {
        return params.find(param => param.key === key).value;
    };

    const getCompanyId = async () => {
        let body = {};
        if(credentials !== undefined){
            body = {
                credentials
            };
        }
        try{
            const options = {
                method: 'POST',
                url: '/connect/company',
                baseURL,
                params: {
                    apikey: apiKey
                },
                headers: {'Content-Type': 'application/json'},
                data: {
                    ...body
                }
            };

            const response = await axios(options);

            if(response.data[0] === true){
                companyID = response.data[1];
                callback && callback(companyID);
                return true;
            }
            else{
                return false;
            }
        }
        catch (err) {
            handleError(err);
            return false;
        }
    }

    const processSuccess = (eCommerce, index, bankIndex) => {
        if(eCommerce.banks){
            eCommerce.banks.forEach((bank, index) => {
                if(bank.isSelected){
                    bank.isSelected = false;
                }
            })
            eCommerce.banks[bankIndex].isSelected = true;
        }
        eCommerce.isSelected = true;
        if(!eCommerce.isNewProcess){
            addData(index);
        }
    }
    
    const process = async (index, oAuthWindow, bankIndex) => {
        if(companyID === null){
            const isSuccess = await getCompanyId();
            if(!isSuccess){
                return { isSuccess: false, error: { code: 11, message: 'error in getting company ID'}};
            }
        }
        
        let isSuccess = true;
        errorMessage = null;
        const eCommerce = eCommerceList[index];
        
        if(eCommerce.getSignedConfig){
            isSuccess = await OauthBankings(index, oAuthWindow);
        }else if(eCommerce.isOAuth || eCommerce.isAuth){
            isSuccess = await oAuth(index, oAuthWindow);
        }
        
        if(isSuccess === true){
            !eCommerce.getOTPConfig && processSuccess(eCommerce, index, bankIndex);
            return { isSuccess: true, showMessage: eCommerce.messageAfterAuth ? eCommerce.messageAfterAuth.body : undefined, oAuthWindow };
        }
        else if(Array.isArray(isSuccess))
        {
            !eCommerce.getOTPConfig && processSuccess(eCommerce, index, bankIndex);
            return { isSuccess: isSuccess, showMessage: eCommerce.messageAfterAuth ? eCommerce.messageAfterAuth.body : undefined, oAuthWindow };
        }
        else {
            return { isSuccess: false, error: { code: 9, showMessage: errorMessage, message: `error in fetching ${bankIndex !== undefined ? eCommerce.banks[bankIndex].code : eCommerce.code} Api`}};
        }
    };

    const setParameters = async (code, args, data, bankCode) => {
        const eCommerce = eCommerceList.find(eCommerce => eCommerce.code === code);
        if(eCommerce == null){
            return { isSuccess: false, error: { code: 20, message: `${code} not found`}};
        }
        const index = eCommerceList.indexOf(eCommerce);
        let bankIndex = undefined;
        if(eCommerce.banks){
            const bank = eCommerce.banks.find(bank => bank.code == bankCode);
            if(bank == null){
                return { isSuccess: false, error: { code: 20, message: `${code} not found`}};
            }
            bankIndex = eCommerce.banks.indexOf(bank);
        }
        let oAuthWindow;
        if(eCommerce.isOAuth){
            oAuthWindow = window.open('', "_blank", 'fullscreen=yes,resizable=yes');
            oAuthWindow.document.body.append('Loading...');
        }
        eCommerce.params.forEach(param => param.value = args[param.key]);
        if(data) {
            eCommerce.data = data;
        }
        return await process(index, oAuthWindow, bankIndex);
    }

    const setOtp = async (code, args) => {
        const eCommerce = eCommerceList.find(eCommerce => eCommerce.code === code);
        if(eCommerce == null){
            return { isSuccess: false, error: { code: 20, message: `${code} not found`}};
        }
        const index = eCommerceList.indexOf(eCommerce);
        if(!eCommerce.getOTPConfig){
            return { isSuccess: false, error: { code: 15, message: `${code} does't require otp`}};
        }

        eCommerce.paramsOTP.forEach(param => param.value = args[param.key]);

        try {
            const config = eCommerce.getOTPConfig();

            const response = await axios(config);

            eCommerce.handleOTPResponse(response.data);
            processSuccess(eCommerce, index);
            return { isSuccess: true };
        } 
        catch (err) {
            handleError(err);
            eCommerce.handleOTPError(err);
            return { isSuccess: false, error: { code: 11, showMessage: errorMessage, message: 'error in OTP verification'}};
        }
    };

    const unselectECommerce = (eCommerce, bankIndex) => {
        if(eCommerce.banks){
            eCommerce.banks[bankIndex].isSelected = false;
        }
        // eCommerce.params.forEach(param => param.value = '');
        eCommerce.isSelected = false;    
        if(eCommerce.messageAfterAuth){
            eCommerce.messageAfterAuth = null;
        }
        if(!eCommerce.isNewProcess){
            delete data[eCommerce.code];
        }
    };

    const getECommerceResponse = async (index) => {
        const eCommerce = eCommerceList[index];
        try {
            const response = await axios(eCommerce.getProfileConfig());

            if(response.data.status_code === undefined || (response.data.status_code == 200 || response.data.status_code == 202)){
                return { 'data': response.data , isError: false };
            }
            if(eCommerce.code == 'shopee'){
                return { 'data': {} , isError: false };
            }
            return { isError: true };
        } 
        catch (err) {
            if(eCommerce.code == 'shopee'){
                return { 'data': {} , isError: false };
            }
            handleError(err);
            return { isError: true };
        }
    };

    const submitData = async (isConfirmed) => {
        if(!isConfirmed){
            return { isSuccess: false, error: { code: 5, message: 'confirmation box not checked'} };
        }
        if(eCommerceList.filter(eCommerce => eCommerce.isSelected).length === 0){
            return { isSuccess: false, error: { code: 6, message: 'no data partner selected'} };
        }

        let isError = false;
        let errorList = [];
        let widget_res = {'gateway_res': {}};
        if(Object.keys(data).length > 0){
            try {
                const headers = { "Content-Type": "application/json" };
                const widget_post_data = JSON.stringify({ id: "string", platforms: data, credentials: {} });
                const response = await axios.post(`https://usermanager-wqzd4eryoa-et.a.run.app/company`, widget_post_data, { headers });
                const display_data = response.data;
                if(display_data[0] === true){
                    try{
                        const auth = { company_id: display_data[1] };
                        const res = await axios.get(`https://gateway-wqzd4eryoa-as.a.run.app/api?company_id=${auth.company_id}&apikey=${apiKey}`);
                        widget_res["gateway_res"] = res.data;
                        if(widget_res["gateway_res"]["location"] !== undefined && widget_res["gateway_res"]["location"]["detail"] === 'Place not found'){
                            isError = true;
                        }
                    }
                    catch(err){
                        handleError(err);
                        isError = true;
                    }
                }
                else{
                    isError = true;
                }
            }
            catch(err){
                handleError(err);
                isError = true;
            }
        }

        if(isError){
            eCommerceList.forEach((eCommerce) => {
                if(eCommerce.isSelected && !eCommerce.isNewProcess){
                    errorList.push(eCommerce.code);
                    unselectECommerce(eCommerce);
                }
            });
        }

        for(let index = 0; index < eCommerceList.length; index++){
            const eCommerce = eCommerceList[index];
            if(!eCommerce.isSelected || !eCommerce.isNewProcess || !eCommerce.getProfileConfig){
                continue;
            }

            const response = await getECommerceResponse(index);

            if(!response.isError){
                widget_res["gateway_res"][eCommerce.code] = response.data;
            }
            else{
                isError = true;
                if(eCommerce.banks){
                    eCommerce.banks.filter(bank => bank.isSelected).forEach((bank, index) => {
                        unselectECommerce(eCommerce, index);
                    });
                }
                else{
                    unselectECommerce(eCommerce);
                }
                errorList.push(eCommerce.code);
            }
        }
    
        if(isError){
            errorList.forEach(code => console.log('error in ', code));
            return { isSuccess: false, error: { code: 10, message: 'error in processing submitted data', data: errorList } };
        }
        else{
            eCommerceList.forEach((eCommerce) => {
                if(eCommerce.isSelected){
                    if(eCommerce.banks){
                        eCommerce.banks.filter(bank => bank.isSelected).forEach((bank, index) => {
                            unselectECommerce(eCommerce, index);
                        });
                    }
                    else{
                        unselectECommerce(eCommerce);
                    }
                }
            });
            previosCompanyID = companyID;
            companyID = null;
            widget_res["gateway_res"]['shopee'] = shopeeResponse;
            return { isSuccess: true, data: widget_res };
        }
    }

    const shopeeResponse = {"shopee_data": {"shop": {"shop_name": "Pake Kataku", "region": "ID", "status": "NORMAL", "is_sip": true, "is_cb": false, "is_cnsc": false, "shop_performance": {"cancellation_rate": "Not enough data", "response_rate": "0.00%", "response_time": "0.00days", "customer_rating": null, "overall": "Good"}}, "orders": {"220910ETWFT5J2": {"create_time": "Sat Sep 10 17:22:23 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662897208, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662810743, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116509943265113", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "220910ETVRUSV2": {"create_time": "Sat Sep 10 17:21:59 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662897180, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662810719, 
    "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116509919248048", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "220910ETUV9158": {"create_time": "Sat Sep 10 17:21:29 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662897151, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662810689, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116509889257583", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "220910ETU5B869": {"create_time": "Sat Sep 10 17:21:06 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662897129, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662810666, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116509865237365", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "220910ETT13R48": {"create_time": "Sat Sep 10 17:20:27 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662897087, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662810627, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116509827218176", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "220910ETS4G9C2": {"create_time": "Sat Sep 10 17:19:57 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662897058, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662810597, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116509797280936", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "220910ETR7XWXH": {"create_time": "Sat Sep 10 17:19:27 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662897028, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662810567, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116509766265048", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, 
    "220910ETQD8KA6": {"create_time": "Sat Sep 10 17:18:59 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662897007, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662810539, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116509739271956", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "220910ETP8197J": {"create_time": "Sat Sep 10 17:18:20 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662896967, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662810500, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116509700236000", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "220910ETM4AFGX": {"create_time": "Sat Sep 10 17:17:09 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662896891, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662810429, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116509629219668", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "220910ETK4TFJ5": {"create_time": "Sat Sep 10 17:16:36 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662896858, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662810396, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116509596276692", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "220910ET0SB29T": {"create_time": "Sat Sep 10 17:06:20 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662896247, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662809780, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116508980257979", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "220910ESYFDR22": {"create_time": "Sat Sep 10 17:05:36 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", 
    "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662896197, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662809736, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116508936238784", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "220910ESX98P94": {"create_time": "Sat Sep 10 17:04:57 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662896167, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662809697, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116508896233341", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "220910ES9YTX0H": {"create_time": "Sat Sep 10 16:53:36 2022", "split_up": false, "cancel_reason": "Don't Want to Buy Anymore", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "buyer", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662809582, "cod": false, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "Don't Want to Buy Anymore", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662809016, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116508215253779", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "220910ES85KN7N": {"create_time": "Sat Sep 10 16:52:35 2022", "split_up": false, "cancel_reason": "Others / change of mind", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "J&T Express", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "buyer", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "COD", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662809548, "cod": true, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "Others / change of mind", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662808955, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116508155221714", "logistics_status": "LOGISTICS_INVALID", "tracking_info": ""}]}, "220910ES758NM0": {"create_time": "Sat Sep 10 16:52:01 2022", "split_up": false, "cancel_reason": "Others / change of mind", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "J&T Express", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "buyer", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "COD", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662809558, "cod": true, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "Others / change of mind", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662808921, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116508121270283", "logistics_status": "LOGISTICS_INVALID", "tracking_info": ""}]}, "220910ES6M2286": {"create_time": "Sat Sep 10 16:51:42 2022", "split_up": false, "cancel_reason": "Others / change of mind", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "J&T Express", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "buyer", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "COD", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662809563, "cod": true, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, 
    "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "Others / change of mind", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662808902, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116508102299120", "logistics_status": "LOGISTICS_INVALID", "tracking_info": ""}]}, "220910ES5NJVB4": {"create_time": "Sat Sep 10 16:51:11 2022", "split_up": false, "cancel_reason": "Others / change of mind", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "J&T Express", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "buyer", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "COD", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662809567, "cod": true, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "Others / change of mind", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662808871, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116508070299145", "logistics_status": "LOGISTICS_INVALID", "tracking_info": ""}]}, "220910ES52EYAC": {"create_time": "Sat Sep 10 16:50:50 2022", "split_up": false, "cancel_reason": "Others / change of mind", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "J&T Express", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "buyer", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "COD", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662809573, "cod": true, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "Others / change of mind", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662808850, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116508049235839", "logistics_status": "LOGISTICS_INVALID", "tracking_info": ""}]}, "220910ES3RFY92": {"create_time": "Sat Sep 10 16:50:06 2022", "split_up": false, "cancel_reason": "Others / change of mind", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "J&T Express", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "buyer", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "COD", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662809595, "cod": true, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "Others / change of mind", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662808806, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116508006276068", "logistics_status": "LOGISTICS_INVALID", "tracking_info": ""}]}, "220910ES2K9SCH": {"create_time": "Sat Sep 10 16:49:28 2022", "split_up": false, "cancel_reason": "Others / change of mind", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "J&T Express", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "buyer", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "COD", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662809599, "cod": true, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "Others / change of mind", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662808768, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116507967233491", "logistics_status": "LOGISTICS_INVALID", "tracking_info": ""}]}, "220910ES1E591K": {"create_time": "Sat Sep 10 16:48:49 2022", "split_up": false, "cancel_reason": "Others / change of mind", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "J&T Express", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "buyer", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "COD", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662809603, "cod": true, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "Others / change of mind", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", 
    "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662808729, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116507929226612", "logistics_status": "LOGISTICS_INVALID", "tracking_info": ""}]}, "220910ERYQRADN": {"create_time": "Sat Sep 10 16:47:51 2022", "split_up": false, "cancel_reason": "Others / change of mind", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "J&T Express", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "buyer", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "COD", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662809607, "cod": true, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "Others / change of mind", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662808671, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116507871270173", "logistics_status": "LOGISTICS_INVALID", "tracking_info": ""}]}, "220910ERWG86E3": {"create_time": "Sat Sep 10 16:46:36 2022", "split_up": false, "cancel_reason": "Others / change of mind", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "J&T Express", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "buyer", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "COD", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1662809611, "cod": true, "buyer_username": "sle.epyofficial", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "Others / change of mind", "recipient_address": {"name": "J******e", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Ja******"}, "buyer_user_id": 80492773, "create_timestamp": 1662808596, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG116507796262640", "logistics_status": "LOGISTICS_INVALID", "tracking_info": ""}]}, "220916043PH3XT": {"create_time": "Fri Sep 16 10:43:39 2022", "split_up": false, "cancel_reason": "", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "SiCepat REG", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": 1663305298, "actual_shipping_fee_confirmed": true, "cancel_by": "", "order_status": "COMPLETED", "total_amount": 17000, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1663702880, "cod": false, "buyer_username": "sabrinaurora26", "dropshipper": "", "pickup_done_time": 1663416387, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "J***o", "phone": "******76", "town": "", "district": "CILANDAK", "city": "KOTA JAKARTA SELATAN", "state": "DKI JAKARTA", "region": "ID", "zipcode": "12440", "full_address": "Jalan Mawar Lestari Indah, RT.3/RW.7, Lb. Bulus, Cilandak (Blok O no 28), KOTA JAKARTA SELATAN, CILANDAK, DKI JAKARTA, ID, 12440"}, "buyer_user_id": 825442184, "create_timestamp": 1663305219, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG117004418296834", "logistics_status": "LOGISTICS_DELIVERY_DONE", "tracking_info": [{"update_time": 1663479761, "description": "Paket telah diterima Julio Yang bersangkutan.", "logistics_status": "DELIVERED"}, {"update_time": 1663471349, "description": "Paket sedang di bawa kurir menuju ke lokasimu.", "logistics_status": "PICKED_UP"}, {"update_time": 1663452857, "description": "Paket telah dikirim dari gudang sortir Jakarta Timur.", "logistics_status": "PICKED_UP"}, {"update_time": 1663426332, "description": "Paket telah dikirim dari gudang sortir Jakarta Barat.", "logistics_status": "PICKED_UP"}, {"update_time": 1663416884, "description": "Paket telah sampai di gudang sortir Jakarta Barat.", "logistics_status": "PICKED_UP"}, {"update_time": 1663414680, "description": "Paket telah diserahkan kepada kurir.", "logistics_status": "PICKED_UP"}, {"update_time": 1663313682, "description": "Pengirim telah mengatur pengiriman. Menunggu paket diserahkan ke pihak jasa kirim.", "logistics_status": "ORDER_CREATED"}]}]}, "22091603X802FQ": {"create_time": "Fri Sep 16 10:40:36 2022", "split_up": false, "cancel_reason": "Need to Change Delivery Address", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "buyer", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Online Payment", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1663305062, "cod": false, "buyer_username": "sabrinaurora26", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 1, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "Need to Change Delivery Address", "recipient_address": {"name": "S******a", "phone": "******82", "town": "", "district": "PALMERAH", "city": "KOTA JAKARTA BARAT", "state": "DKI JAKARTA", "region": "ID", "zipcode": "11480", "full_address": "Ko******"}, "buyer_user_id": 825442184, "create_timestamp": 1663305036, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 1, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG117004236275224", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}, "221004H6Q90DEV": {"create_time": "Tue Oct  4 19:32:19 2022", "split_up": false, "cancel_reason": "Unpaid Order", "days_to_ship": 2, "dropshipper_phone": "", "shipping_carrier": "", "estimated_shipping_fee": 9000, "region": "ID", "pay_time": null, "actual_shipping_fee_confirmed": false, "cancel_by": "system", "order_status": "CANCELLED", "total_amount": 0, "payment_method": "Alfamart", "checkout_shipping_carrier": "Reguler (Cashless)", "update_time": 1664978606, "cod": false, "buyer_username": "tiyo280375", "dropshipper": "", "pickup_done_time": 0, "currency": "IDR", "reverse_shipping_fee": 0, "item_list": [{"item_id": 16383982633, "item_name": "Gelang Karet Champion", "item_sku": "", "model_id": 0, "model_name": "", "model_sku": "", "model_quantity_purchased": 2, "model_original_price": 7000, "model_discounted_price": 7000, "wholesale": false, "weight": 0.1, "add_on_deal": false, "main_item": false, "add_on_deal_id": 0, 
    "promotion_type": "", "promotion_id": 0, "order_item_id": 16383982633, "promotion_group_id": 0, "image_info": {"image_url": "https://cf.shopee.co.id/file/fcea49ecf0ee5eeda66fb9f16f41c77b_tn"}, "product_location_id": null, "is_prescription_item": false, "is_b2c_owned_item": false}], "buyer_cancel_reason": "", "recipient_address": {"name": "k******n", "phone": "******12", "town": "", "district": "CAKUNG", "city": "KOTA JAKARTA TIMUR", "state": "DKI JAKARTA", "region": "ID", "zipcode": "13910", "full_address": "ru******"}, "buyer_user_id": 421177438, "create_timestamp": 1664892139, "product_list": [{"product_id": 16383982633, "product_name": "Gelang Karet Champion", "quantity": 2, "original_price": 7000, "discounted_price": 7000, "wholesale": false, "is_prescription_item": false, "package_number": "OFG118591339245492", "logistics_status": "LOGISTICS_NOT_START", "tracking_info": "The order is being allocated, please wait until the allocate is completed."}]}}, "products": {"16383982633": {"item_sale": 1, "item_rating": 0, "item_likes": 1, "item_views": 42}}}, "platform": "shopee", "id": "536faf3f508d4e15bed3ecfc81666c0f"};
    
    this.setParameters = async (code, args, data, bankCode) => {
        return await setParameters(code, args, data, bankCode);
    }

    this.setOtp = async (code, args) => {
        return await setOtp(code, args);
    }

    this.unselect = (code, bankCode) => {
        const eCommerce = eCommerceList.find(eCommerce => eCommerce.code === code);
        if(eCommerce == null){
            return { isSuccess: false, error: { code: 20, message: `${code} not found`}};
        }
        const index = eCommerceList.indexOf(eCommerce);
        if(!eCommerce.isSelected){
            return { isSuccess: false, error: { code: 13, message: `${code} already unselected`}};
        }
        let bankIndex = undefined;
        if(eCommerce.banks){
            const bank = eCommerce.banks.find(bank => bank.code == bankCode);
            if(bank == null){
                return { isSuccess: false, error: { code: 20, message: `${code} not found`}};
            }
            bankIndex = eCommerce.banks.indexOf(bank);
        }
        unselectECommerce(eCommerce, bankIndex);
        return { isSuccess: true };
    }

    this.submit = async (isConfirmed) => {
        if(isConfirmed !== true){
            isConfirmed = false;
        }
        return await submitData(isConfirmed);
    }

    this.getProfileData = async (code, isCurrent) => {
        const eCommerce = eCommerceList.find(eCommerce => eCommerce.code === code);
        if(eCommerce == null){
            return { isSuccess: false, error: { code: 20, message: `${code} not found`}};
        }
        try {
            const config = eCommerce.getProfileConfig();
            if(!isCurrent){
                config.params.id = previosCompanyID;
            }

            const response = await axios(config);

            if(response.data.status_code === undefined || (response.data.status_code == 200 || response.data.status_code == 202)){
                return { 'data': response.data , isError: false };
            }
            return { isError: true };
        } 
        catch (err) {
            handleError(err);
            return { isError: true };
        }
    }

};

 export default PWC;